<template>
	<div 
		class="gb-photoalbum-edit" 
		v-bind:style="styleAlbumEdit">
		<Loading v-if="loading" opacity="0.5"/>
		<GBPhotoAlbumDrop
			@drop="onChangeFile"
		/>
		<GBPhotoAlbumHeader 
			v-bind:backURL="backURL" />
		<div class="d-flex" style="z-index: 103;">
			<GBPhotoAlbumListAlbumHeader 
				v-bind:name="list_albums.name"
				v-bind:begin="list_albums.begin"
				v-bind:end="list_albums.end"
				v-bind:title="list_albums.title"/>
			<div class="gb-header-photo-list" v-bind:style="stylePhotoList">
				<div class="primary gb-header-photo-layout">
					<template v-if="!is_selecting_images">
						<v-layout align-center row fill-height>
							<v-btn flat large color="white" class="pa-0"
								v-bind:disabled="hasParent() == false"
								v-on:click="onClickDeleteAlbum">削除</v-btn>
							<v-spacer></v-spacer>
							<div class="d-flex">
								<v-select dark 
									ref="select_quality"
									v-model="selected_quality"
									v-bind:items="item_quality"
									item-text="name"
									item-value="value"
									style="width: 100px; margin-left:8px; margin-right:8px;"
									v-bind:disabled="hasParent() == false"
									v-on:input="onInputImageQuality">
								</v-select>
							</div>
							<v-btn flat large color="white" class="pa-0"
								v-bind:disabled="hasParent() == false"
								v-on:click="onPhotoUpload">写真を登録</v-btn>
							<input id="select_photo" type="file" v-on:change="onChangeFile" style=" display: none;" multiple/>
							<div style="width:151px">
								<v-btn 
									v-if="!download_album" 
									flat large color="white" class="pa-0" 
									v-bind:disabled="hasParent() == false" 
									v-on:click="onClickDownloadAll">すべてダウンロード</v-btn>
								<v-btn v-else flat block large color="white" disabled>
									<v-progress-circular
										indeterminate
										color="white"
									></v-progress-circular>
								</v-btn>
							</div>
							<v-btn flat large color="white" class="pa-0" 
								style="min-width:30px"
								v-bind:disabled="hasParent() == false"
								v-on:click="onClickStartSelectingImages">選択</v-btn>
						</v-layout>
					</template>
					<template v-else>
						<v-layout align-center row fill-height>
							<v-btn flat dark color="white" @click="onClickCancelSelectingImages">キャンセル</v-btn>
							<v-spacer />
							<h4 class="album-title" style="color: #FFFFFF;">{{ selected_images.length }}枚を選択中</h4>
							<v-spacer />
							<v-btn flat dark color="white" @click="onClickSelectAllImages">すべて選択</v-btn>
						</v-layout>
					</template>
				</div>
			</div>
		</div>
		<div class="d-flex">
			<GBPhotoAlbumSelectList 
				v-bind:items= "listItems"
				v-bind:select_id="photoalbum_id"
				v-on:select-list="selectPhotoAlbum"/>
			<div 
				class="gb-album-content-outer" 
				v-bind:style="styleContentOuter">
				<div class="content" v-bind:style="stylePhotoListHeight">
					<div v-if="hasParent()"
						class="gb-photo-list" 
						v-bind:style="stylePhotoList">
						<div class="pa-2">
							<span>更新日：{{album.last_modified_at}}</span><br>
							<v-form ref="form_title" v-on:submit.prevent="onSubmitTitle">
								<v-text-field
									ref="input_title"
									v-model="album.title"
									maxlength="50"
									v-bind:rules="[RULES.required, RULES.length_title]"
									v-bind:append-outer-icon="is_selecting_images ? undefined : is_title_editing ? 'done' : undefined"
									single-line
									v-bind:readonly="!is_title_editing"
									v-on:focus="onFocusTitle"
									v-on:click:append-outer="onClickEditTitle"
								/>
							</v-form>
							<h2>写真</h2>
							<template v-if="album.items.length > 0">
								<v-layout wrap row align-content-start>
									<div style="position: relative; display: inline-block; margin-right:10px" 
										v-for="item in album.items" 
										:key="item.id">
										<div style="cursor: pointer;" 
											v-on:click="onClickImage(item.id)" 
											v-on:mouseenter="onMouseEnter(item.id)" 
											v-on:mouseleave="onMouseLeave">
											<v-lazy-image :src="item.thumbnail_uri" style="height: 200px;" />
											<div class="insert-member-name" v-show="hover_item === item.id">
												by {{item.insert_member_name}}
											</div>
										</div>
										<v-btn v-if="is_selecting_images" fab
											color="white"
											v-bind:outline="!isSelectedImage(item.id)"
											@click="onClickToggleSelectImage(item.id)"
											style="position: absolute; top: 5px; right: 5px;"
											small>
											<v-icon v-if="isSelectedImage(item.id)">done</v-icon>
										</v-btn>
									</div>
								</v-layout>
							</template>
							<template v-else>
								<v-alert color="info" dense outline :value="true" align="center">
									写真が登録されていません。
								</v-alert>
							</template>
						</div>
					</div>
				</div>
				<v-layout class="gb-selecting-menu white" align-center row outline v-if="is_selecting_images" v-bind:style="styleSelectingMenu">
					<v-btn flat block dark class="ma-0" color="#ff5252" v-on:click="onClickDeleteSelectedImages">削除</v-btn>
					<v-btn flat block dark class="ma-0" color="primary" v-on:click="onClickDownload">ダウンロード</v-btn>
				</v-layout>
			</div>
		</div>
		<GBDialog
			:dialog="dialog" 
			@agree="onClickDialogAgree"
			@disagree="onClickDialogDisagree"
		/>
		<DialogConfirmDeletePhotoAlbum
			:display="dialog_del_album.display"
			@click-cancel="onClickCancelDeleteAlbum"
			@click-confirm="onClickConfirmDeleteAlbum"
		/>
		<DialogConfirmDeletePhotoAlbumItem
			:display="dialog_del_items.display"
			@click-cancel="onClickCancelDeleteImages"
			@click-confirm="onClickConfirmDeleteImages"
		/>
	</div>
</template>
<script>
import Notification from '../../classes/Notification';
import GBPhotoAlbumListAlbumHeader from './GBPhotoAlbumListAlbumHeader';
import GBPhotoAlbumSelectList from './GBPhotoAlbumSelectList';
import GBPhotoAlbumHeader from './GBPhotoAlbumHeader';
import GBPhotoAlbumDrop from './GBPhotoAlbumDrop';
import GBDialog from '../GBDialog';
import DialogConfirmDeletePhotoAlbum from './DialogConfirmDeletePhotoAlbum';
import DialogConfirmDeletePhotoAlbumItem from './DialogConfirmDeletePhotoAlbumItem';
import Loading from '../Loading';
import APIClient from '../../classes/APIClient';
import uuidv4 from 'uuid/v4';
import ConoHa from '../../classes/ConoHa';
import Util from '../../classes/Util'
import { IMAGE_MAX_SIZE, PHOTOALBUM_IMAGE_MAX_COUNT, GANTTBOARD_EVENT_ID, ARCHIVE_TYPE, DATETIME_FORMAT } from '../../data/Const';
import VLazyImage from 'v-lazy-image';
import clonedeep from 'lodash/cloneDeep';

const HEADER_HEIGHT = 30;
const HEADER_ALBUM_HEIGHT = 59;

const chunkSplitPromiseAll = async (items, callback) => {
	let i, j, k, chunk_size = 5;

	for (i=0,j=items.length; i<j; i+=chunk_size) {
		let chunk = [];
		for (k=i; k < i + chunk_size; k++) {
			if (items[k] !== undefined)
				chunk.push(items[k]);
		}
		await Promise.all(chunk.map(callback));
	}
};

const validateLengthTitle = (value) => {
	if (value === undefined || value === null)
		return false;
	if (value.length <= 50)
		return true;

	return false;
};

const IMAGE_QUALITY = {
	DEFAULT: 0,
	HIGH_RESOLUTION: 1,
};
const strftime = require('strftime');
export default {
	name: 'GBPhotoAlbumEdit',
	props: [
	],
	data: function() {
		return {
			album: {
				title: null,
				last_modified_at: null,
				items: []
			},
			api: new APIClient(this.$store),
			list_albums: {
				name: null,
				begin: null,
				end: null,
				title: null,
				albums: [],
			},
			photoalbum_id: null,
			project_id: null,
			schedule_id: null,
			member_id: null,
			conoha: null,
			is_selecting_images: false,
			is_camera_resolution_original: false,
			selected_images: [],
			dialog: {
				display: false,
				title: null,
				text: null,
				disagree: null,
				agree: null,
			},
			dialog_del_album: { display: false },
			dialog_del_items: { display: false },
			loading: false,
			item_quality: [{
				value: IMAGE_QUALITY.DEFAULT,
				name: "標準",
				}, {
				value: IMAGE_QUALITY.HIGH_RESOLUTION,
				name: "高画質",
			}],
			selected_quality:0,
			RULES: {
				required: v => !!v || '入力してください',
				length_title: v => validateLengthTitle(v) || '50文字以内で入力してください',
			},
			is_title_editing: false,
			hover_item: '',
			download_album: false,
		};
	},
	components: {
		VLazyImage,
		GBPhotoAlbumListAlbumHeader,
		GBPhotoAlbumSelectList,
		GBPhotoAlbumHeader,
		GBPhotoAlbumDrop,
		GBDialog,
		DialogConfirmDeletePhotoAlbum,
		DialogConfirmDeletePhotoAlbumItem,
		Loading,
	},
	methods: {
		initData: async function(route) {
			this.loading = true;
			this.photoalbum_id = route.hash.replace('#', '');
			this.list_albums = {
				name: null,
				begin: null,
				end: null,
				title: null,
				albums: [],
			};
			this.album = {
				title: null,
				last_modified_at: null,
				items: []
			};
			this.project_id = null;
			this.schedule_id = null;
			this.member_id = null;
			this.is_selecting_images = false;
			this.is_camera_resolution_original = false;
			this.selected_images = [];
			this.dialog = {
				display: false,
				title: null,
				text: null,
				disagree: null,
				agree: null,
			};
			this.dialog_del_album = { display: false };
			this.dialog_del_items = { display: false };
			this.selected_quality = 0;
			this.is_title_editing = false;
			this.hover_item = '';
			this.download_album = false;
			
			return await this.getPhotoAlbumList()
				.then(() => {
					this.getPhotoAlbum(this.photoalbum_id)
						.then(() => {
							this.loading = false;
						});
				});
		},
		hasParent: function() {
			return this.list_albums.name !== null && this.list_albums.albums.length > 0 && this.album.title !== null;
		},
		onUpdatePhotoAlbum: async function(data) {
			if (data.photoalbum_id !== this.photoalbum_id)
				return;
			if (this.is_title_editing)
				return;
			this.loading = true;
			this.$store.dispatch('addNotification', Notification.info('アルバムを同期しました'));
			this.list_albums = {
				name: null,
				begin: null,
				end: null,
				title: null,
				albums: [],
			};
			this.loading = true;
			await this.getPhotoAlbumList()
				.then(async () => {
					this.album = {
						title: null,
						last_modified_at: null,
						items: []
					};
					await this.getPhotoAlbum(this.photoalbum_id)
						.then(() => {
							this.selected_images = this.selected_images.filter(selected => {
								return this.album.items.find(item => item.id == selected );
							});
						});
				})
				.finally(() => {
					this.loading = false;
				});
		},
		onDownloadPhotoAlbum: function() {
			this.download_album = false;
		},
		onUpdateDataSet: async function () {
			this.loading = true;
			this.list_albums = {
				name: null,
				begin: null,
				end: null,
				title: null,
				albums: [],
			};
			await this.getPhotoAlbumList().then(() => {
				this.loading = false;
			});
		},
		onPhotoUpload: function() {
			if(!this.is_title_editing)
				document.getElementById("select_photo").click();
			else
				this.$refs.input_title.focus();
		},
		onChangeFile: async function(e) {
			let files = e.target.files || e.dataTransfer.files;
			
			if (PHOTOALBUM_IMAGE_MAX_COUNT < this.album.items.length + files.length) {
				this.errorDialog("登録の上限を超えています。\n[" + PHOTOALBUM_IMAGE_MAX_COUNT + '枚まで]');
				return;
			}
			
			this.loading = true;
			let failure = [];
			let images = [];
			let items = [];
			
			let size_list = this.is_camera_resolution_original ? [
				IMAGE_MAX_SIZE.ORIGINAL,
				IMAGE_MAX_SIZE.THUMBNAIL,
			] : [ IMAGE_MAX_SIZE.SXGA,
				IMAGE_MAX_SIZE.THUMBNAIL,
			];
			await chunkSplitPromiseAll(files, async (file) => {
				let name = file.name;
				let type = file.type;
				let item_id = uuidv4();
				let id = ['photoalbum', this.photoalbum_id, item_id].join('/');
				let item = {
					id: item_id,
					thumbnail_uri: null,
					photo_uri: null,
				};
				items.push(item);
				await Promise.all(size_list.map(size => {
					return this.conoha.generateImage(file, size)
						.then(async (res) => {
							images.push({
								'blob': res.blob,
								'src' : res.url,
								'name': size.PREFIX + name,
								'type': type,
								'size': size,
								'id': id + size.SUFFIX,
								'setURI': uploaded => {
									if (size === IMAGE_MAX_SIZE.THUMBNAIL)
										item.thumbnail_uri = uploaded.src;
									else
										item.photo_uri = uploaded.src;
								},
							});
						})
						.catch((e) => {
							failure.push(e);
						});
				}));
			});
			
			if (failure.length > 0) {
				this.loading = false;
				this.error("ファイルの読み込みに失敗しました");
				return;
			}
			
			this.uploadToConoHa(images)
				.then(async () => {
					await this.api.appendPhotoAlbumItems(this.photoalbum_id, items)
						.then(async () =>{
							this.album = {
								title: null,
								last_modified_at: null,
								items: []
							};
							await this.getPhotoAlbum(this.photoalbum_id);
							this.loading = false;
						})
				})
				.catch(() => {
					this.loading = false;
					if (e.token) {
						this.logout();
						return;
					}
					this.error('画像のアップロードに失敗しました');
				});
		},
		uploadToConoHa: async function(images) {
			let uploaded = [];
			let failure = [];
			await Util.chunkSplitPromiseAll(images, async (image) => {
				let headers = {
					'X-Object-Meta-name': encodeURIComponent(image.name),
					'Content-Disposition': 'attachment; filename=' + encodeURIComponent(image.name),
					'Content-Type': image.type,
				};
				try {
					let res = await this.conoha.upload(image.blob, headers, image.id);
					if (image.setURI)
						image.setURI(res);
					uploaded.push(res);
				} catch {
					failure.push(image.name);
				}
			});
			if (failure.length > 0) {
				throw ('upload error');
			}
		},
		onWindowResize: function() {
			Util.onWindowResize(() => {
				this.$store.dispatch('setWindowSize', {
					width: window.innerWidth,
					height: window.innerHeight,
				});
			});
		},
		selectPhotoAlbum: function(id) {
			let path = location.pathname;
			let uri = path + '#' + id;
			this.$router.push(uri);
		},
		getPhotoAlbum: async function(id) {
			this.photoalbum_id = id;
			await this.api.getPhotoAlbum(id)
				.then((res) => {
					this.album.items = res.data.items;
					let utc = Util.getUTCFromYMDHMS(res.data.last_modified_at);
					this.album.title = res.data.title;
					this.album.last_modified_at = strftime(DATETIME_FORMAT, new Date(utc));
					this.api.updateBrowseHistory(this.photoalbum_id);
				})
				.catch((e) => {
					if (e.token) {
						this.logout();
						return;
					}
					switch (e.response.status) {
					case 404:
						this.error('アルバムが見つかりません');
						break;
					default:
						this.error('アルバムの取得に失敗しました');
					}
				});
		},
		onClickStartSelectingImages: function() {
			if(!this.is_title_editing)
				this.is_selecting_images = true;
			else
				this.$refs.input_title.focus();
		},
		onClickImage: function(id) {
			if (this.is_selecting_images)
				return this.onClickToggleSelectImage(id);
			
			let path = location.pathname;
			let uri = path + this.photoalbum_id + '/slideshow#' + id;
			this.$router.push(uri);
		},
		onClickToggleSelectImage: function(id) {
			let index = this.selected_images.indexOf(id);
			if (index >= 0)
				this.selected_images.splice(index, 1);
			else
				this.selected_images.push(id);
		},
		onClickCancelSelectingImages: function() {
			this.is_selecting_images = false;
			this.selected_images = [];
		},
		onClickSelectAllImages: function() {
			this.selected_images = this.album.items.map(item => item.id);
		},
		onClickDeleteSelectedImages: async function() {
			if (this.selected_images.length === 0) {
				this.errorDialog('画像を選択してください');
				return;
			}
			this.dialog_del_items.display = true;
		},
		onClickCancelDeleteImages: function() {
			this.dialog_del_items.display = false;
		},
		onClickConfirmDeleteImages: async function() {
			this.dialog_del_items.display = false;
			
			let items = this.selected_images.map((id) => {
				return this.album.items.filter(item => item.id === id)[0];
			});
			this.loading = true;
			try {
				await this.api.deletePhotoAlbumItems(this.photoalbum_id, items)
					.then(async () => {
						this.album = {
							title: null,
							last_modified_at: null,
							items: []
						};
						await this.getPhotoAlbum(this.photoalbum_id);
						this.deleteFromConoHa(items);
						this.onClickCancelSelectingImages();
					})
					.catch((e) => {
						if (e.token) {
							this.logout();
							return;
						}
						this.error('写真の削除に失敗しました');
					});
			} finally {
				this.loading = false;
			}
		},
		onClickDialogDisagree: function() {
			if (this.dialog.disagree)
				this.dialog.disagree();
			return;
		},
		onClickDialogAgree: function() {
			if (this.dialog.agree)
				this.dialog.agree();
			return;
		},
		deleteFromConoHa: async function(items) {
			await chunkSplitPromiseAll(items, async (item) => {
				/* サムネイルは残す */
				// await this.conoha.deleteByURI(item.thumbnail_uri);
				await this.conoha.deleteByURI(item.photo_uri);
			});
		},
		onClickDeleteAlbum: function() {
			this.dialog_del_album.display = true;
		},
		onClickCancelDeleteAlbum: function() {
			this.dialog_del_album.display = false;
		},
		onClickConfirmDeleteAlbum: function() {
			this.dialog_del_album.display = false;
			this.loading = true;

			this.api.deletePhotoAlbum(this.photoalbum_id)
				.then(async () => {
					await this.deleteFromConoHa(this.album.items);
					this.onClickBack();
				})
				.catch((e) => {
					if (e.token) {
						this.logout();
						return;
					}
					this.error('削除に失敗しました');
				})
				.then(() => {
					this.loading = false;
				});
		},
		onClickBack: function() {
			let uri;
			if (this.$route.params.project_id && !this.$route.params.schedule_id) {
				uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'project'].join('/') + '/#' + this.project_id;
			} else if(this.$route.params.project_id && this.$route.params.schedule_id) {
				uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'project', this.project_id].join('/') + '/#' + this.schedule_id;
			} else if(this.$route.params.member_id && this.$route.params.schedule_id) {
				uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'member', this.member_id].join('/') + '/#' + this.schedule_id;
			} else {
				this.error('');
				return;
			}
			this.$router.push(uri);
		},
		onInputImageQuality: function(e) {
			if (e === IMAGE_QUALITY.DEFAULT)
				this.is_camera_resolution_original = false;
			else
				this.is_camera_resolution_original = true;
			
			this.$refs.select_quality.blur();
		},
		onFocusTitle: function() {
			if (this.is_selecting_images)
				return;

			this.is_title_editing = true;
		},
		onSubmitTitle: function() {
			if (this.is_title_editing)
				this.onClickEditTitle();
		},
		onClickEditTitle: function() {
			if (!this.is_title_editing)
				return;

			if (!this.$refs.form_title.validate()) {
				return;
			}
			this.loading = true;
			this.updateAlbumTitle(this.photoalbum_id, this.album)
				.then(() => {
					this.loading = false;
					this.is_title_editing = false;
					document.activeElement.blur();
				})
				.catch(async (e) => {
					this.is_title_editing = false;
					this.loading = false;
					switch (e.response.status) {
					case 404:
						this.album = {
							title: null,
							last_modified_at: null,
							items: []
						};
						this.list_albums = {
							name: null,
							begin: null,
							end: null,
							title: null,
							albums: [],
						};
						await this.getPhotoAlbumList();
						this.error('アルバムが見つかりません');
						break;
					default:
						this.error('更新に失敗しました');
						break;
					}
					
				});
		},
		updateAlbumTitle: async function(photoalbum_id, album) {
			return this.api.updatePhotoAlbum(photoalbum_id, {
				'title': album.title,
			}).then(async (res) => {
				this.list_albums = {
					name: null,
					begin: null,
					end: null,
					title: null,
					albums: [],
				};
				await this.getPhotoAlbumList();
				this.album.title = res.data.title;
				let utc = Util.getUTCFromYMDHMS(res.data.last_modified_at);
				this.album.last_modified_at = strftime(DATETIME_FORMAT, new Date(utc));
				this.api.updateBrowseHistory(this.photoalbum_id);
			}).catch((e) => {
				if (e.token) {
					this.logout();
					return;
				}
				throw e;
			});
		},
		onClickDownload: function() {
			if (this.selected_images.length === 0) {
				this.errorDialog('画像を選択してください');
				return;
			} else if (this.selected_images.length === 1) {
				let id = this.selected_images[0];
				let index = this.album.items.findIndex(item => {
					return item.id == id;
				});
				if (index < 0)
					return undefined;
				
				let item = this.album.items[index];
				if (item) {
					let a = document.createElement('a');
					a.setAttribute('href', item.photo_uri);
					a.setAttribute('download', '');
					document.body.appendChild(a);
					try {
						a.click();
					} finally {
						document.body.removeChild(a);
					}
				}
			} else {
				this.download_album = true;
				
				let socketio_id = this.$store.getters.socketioID;
				this.api.downloadArchive(this.project_id, 
											this.member_id, 
											this.schedule_id, 
											this.photoalbum_id, 
											socketio_id, 
											this.selected_images, 
											ARCHIVE_TYPE.ALBUM_SELECTED)
					.catch((e) => {
						if (e.token) {
							this.logout();
							return;
						}
						this.download_album = false;
						this.error('ダウンロードに失敗しました');
					});
			}
			
			this.is_selecting_images = false;
			this.selected_images = [];
		},
		onClickDownloadAll: function() {
			if(this.is_title_editing) {
				this.$refs.input_title.focus();
				return;
			}

			this.download_album = true;
			let socketio_id = this.$store.getters.socketioID;
			this.api.downloadArchive(
				this.project_id, this.member_id, this.schedule_id, this.photoalbum_id, 
				socketio_id, null, ARCHIVE_TYPE.ALBUM_ALL
			)
				.catch((e) => {
					if (e.token) {
						this.logout();
						return;
					}
					this.download_album = false;
					this.error('ダウンロードに失敗しました');
				});
		},
		getPhotoAlbumList: async function() {
			if (this.$route.params.project_id && !this.$route.params.schedule_id) {
				this.project_id = this.$route.params.project_id;
				await this.api.getPhotoAlbumListOfProject(this.project_id).then((res) => {
						this.list_albums.albums = res.data.album_list;
						this.list_albums.name = res.data.project.name;
					}).catch((e) => {
						if (e.token) {
							this.logout();
							return;
						}
						
						switch (e.response.status) {
						case 404:
							this.error('案件、もしくはスケジュールが削除されました');
							this.is_selecting_images = false;
							this.selected_images = [];
							this.album = {
								title: null,
								last_modified_at: null,
								items: []
							};
							break;
						default:
							this.error('アルバムの取得に失敗しました');
						}
					});
			} else if (this.$route.params.schedule_id) {
				this.schedule_id = this.$route.params.schedule_id;
				await this.api.getPhotoAlbumListOfSchedule(this.schedule_id).then((res) => {
						this.list_albums.albums = res.data.album_list;
						if (this.$route.params.project_id)
							this.list_albums.name = res.data.member.name;
						else if (this.$route.params.member_id)
							this.list_albums.name = res.data.project.name;
						this.list_albums.begin = res.data.schedule.begin;
						this.list_albums.end = res.data.schedule.end;
						this.list_albums.title = res.data.schedule.title;
						this.project_id = res.data.project.id;
						this.member_id = res.data.member.id;
					}).catch((e) => {
						if (e.token) {
							this.logout();
							return;
						}
						
						switch (e.response.status) {
						case 404:
							this.error('案件、もしくはスケジュールが削除されました');
							this.is_selecting_images = false;
							this.selected_images = [];
							this.album = {
								title: null,
								last_modified_at: null,
								items: []
							};
							break;
						default:
							this.error('アルバムの取得に失敗しました');
						}
					});
			}
			
			this.list_albums.albums.forEach((i) => {
				if(i.id === this.photoalbum_id && !i.reference)
					i.reference = 1;
			});
		},
		errorDialog: function(text) {
			this.dialog.title = 'エラー';
			this.dialog.text = text;
			this.dialog.disagree = null;
			this.dialog.agree = () => {
				this.dialog.display = false;
				this.dialog.agree = null;
			};
			this.dialog.display = true;
		},
		error: function(text) {
			this.$store.dispatch('addNotification', Notification.error(text));
		},
		logout: function() {
			this.$store.dispatch('addNotification', Notification.error('もう一度ログインしてください'));
			this.$store.dispatch('logout');
			this.$router.push({name: 'Login', params: { 'contractor_id': this.$route.params.contractor_id }});
		},
		onMouseEnter: function(item) {
			this.hover_item = item;
		},
		onMouseLeave: function () {
			this.hover_item = '';
		},
	},
	computed: {
		backURL: function() {
			let uri;
			if (this.hasParent()) {
				if (this.$route.params.project_id && !this.$route.params.schedule_id) {
					uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'project'].join('/') + '/#' + this.project_id;
				} else if(this.$route.params.project_id && this.$route.params.schedule_id) {
					uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'project', this.project_id].join('/') + '/#' + this.schedule_id;
				} else if(this.$route.params.member_id && this.$route.params.schedule_id) {
					uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'member', this.member_id].join('/') + '/#' + this.schedule_id;
				}
			} else {
				if (this.$route.params.project_id) {
					uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'project'].join('/');
				} else if (this.$route.params.member_id) {
					uri = '/' + [this.$route.params.contractor_id, 'photoalbum', 'member'].join('/');
				}
			}
			return uri;
		},
		styleAlbumEdit: function() {
			let left = this.$store.getters.boardLeftPosition;
			let width = this.$store.getters.width - left;

			return {
				width: width + 'px',
				left: left + 'px',
			};
		},
		styleContentOuter: function() {
			let header = 90;
			return {
				height: (this.$store.getters.height - header) + 'px',
			};
		},
		stylePhotoList: function() {
			let left = this.$store.getters.boardLeftPosition;
			let width = this.$store.getters.width - 317;
			
			return {
				width: width + 'px',
				left: left + 'px',
			};
		},
		stylePhotoListHeight: function() {
			let height = this.$store.getters.height - HEADER_HEIGHT - HEADER_ALBUM_HEIGHT;
			if (this.is_selecting_images)
				height -= 50;
			return {height: height + 'px'};
		},
		styleSelectingMenu: function() {
			let width = this.$store.getters.width - 298;
			
			return {
				width: width + 'px'
			};
		},
		isSelectedImage: function() {
			return (id) => this.selected_images.indexOf(id) >= 0;
		},
		listItems: function() {
			return clonedeep(this.list_albums.albums).map(item => {
				return {
					'id': item.id,
					'name': item.title,
					'reference': item.reference,
				};
			});
		},
	},
	mounted(){
		this.conoha = new ConoHa(this.$store.getters.datasetManager);
		this.initData(this.$route);
		
		this.$store.commit('addGanttBoardEventListener', {
			type: GANTTBOARD_EVENT_ID.PHOTOALBUM_UPDATE,
			listener: this.onUpdatePhotoAlbum,
		});
		this.$store.commit('addGanttBoardEventListener', {
			type: GANTTBOARD_EVENT_ID.ALBUM_DOWNLOAD,
			listener: this.onDownloadPhotoAlbum,
		});
		this.$store.commit('addGanttBoardEventListener', {
			type: GANTTBOARD_EVENT_ID.DATASET_UPDATE,
			listener: this.onUpdateDataSet,
		});
	},
	created: function() {
		window.addEventListener('resize', this.onWindowResize, false);
		this.onWindowResize();
	},
	beforeRouteUpdate(to, from, next) {
		this.initData(to)
			.then(() => {
				next();
			});
	},
	beforeDestroy: function() {
		window.removeEventListener('resize', this.onWindowResize);
		this.$store.commit('removeGanttBoardEventListener', {
			type: GANTTBOARD_EVENT_ID.PHOTOALBUM_UPDATE,
			listener: this.onUpdatePhotoAlbum,
		});
		this.$store.commit('removeGanttBoardEventListener', {
			type: GANTTBOARD_EVENT_ID.ALBUM_DOWNLOAD,
			listener: this.onDownloadPhotoAlbum,
		});
		this.$store.commit('removeGanttBoardEventListener', {
			type: GANTTBOARD_EVENT_ID.DATASET_UPDATE,
			listener: this.onUpdateDataSet,
		});
	},
};
</script>
<style>
	.gb-photoalbum-edit {
		-moz-user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
	}
	.gb-photoalbum-edit-drag {
		position: relative;
		-moz-user-select: none;
		-webkit-user-select: none;
		-ms-user-select: none;
		overflow-y: hidden;
		overflow-x: hidden;
		width: 100%;
		height: 100%;
	}
	.gb-photoalbum-edit-drag .content {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		margin: auto;
		width: 80%;
		height:50%;
		text-align: center;
		color: #FFF;
	}
	.gb-photoalbum-edit-drag .gb-photo-list {
		position: relative;
	}
	.gb-photoalbum-edit .gb-album-content-outer {
		overflow-y: hidden;
		overflow-x: hidden;
		width: 100%;
		-webkit-overflow-scrolling: touch;
	}
	.gb-photoalbum-edit .gb-album-content-outer .content {
		overflow-y: scroll;
		overflow-x: hidden;
		width: 100%;
		height: 100%;
		-webkit-overflow-scrolling: touch;
		overscroll-behavior-y: contain;
		background-color: white;
	}
	.gb-photoalbum-edit .gb-header-photo-list {
		position: relative;
		border:solid 1px #DFDFDF;
		height: 59px;
		border-left: none;
	}
	.gb-photoalbum-edit .gb-header-photo-layout {
		position: relative;
		padding: 0px 19px 0px 0px;
		height: 57px;
	}
	.gb-photoalbum-edit .gb-photo-edit-list {
		border-right: 1px solid #dfdfdf;
	}
	.gb-photoalbum-edit .album-name {
		font-size: x-large;
		border-bottom: solid;
	}
	.gb-photoalbum-edit .insert-member-name {
		position: absolute;
		top: 0px;
		left: 0px;
		width:100%;
		background-color: rgba( 0, 0, 0, 0.55 );
		color: #FFF;
		padding-left: 10px;
	}
	.gb-photoalbum-edit .gb-selecting-menu {
		position: fixed;
		bottom: 0;
		background-color: white;
		border-top: 1px solid;
		height: 50px;
		box-shadow: -10px 10px 10px 10px rgba(0,0,0,0.4);
	}
</style>
